const settings = window.drupalSettings?.dehnMeilisearchQuick ?? {};
const lang = settings.lang ?? document.documentElement.lang;
const locale = settings.productLocale;
const country = settings.productCountry;

const PAGES_INDEX = settings.contentIndex ?? '';
const CONTENT_FILTER = settings.contentFilter ?? [];
const PRODUCTS_INDEX = settings.productsIndex ?? 'stibo-product-data-v1';

if (settings.useMeilisearch) {
  // Direct multi-search fetch for all supported languages
  initFetchSearch();
} else {
  // Fallback to DehnSearch for unsupported languages (zh-hans, ja)
  initDehnSearch();
}

function clearResults() {
  document.getElementById('hits-pages-wrapper').hidden = true;
  document.getElementById('hits-products-wrapper').hidden = true;
  const noResults = document.getElementById('search-no-results');
  if (noResults) noResults.hidden = true;
}

function renderNoResults(hasResults) {
  const noResults = document.getElementById('search-no-results');
  if (!noResults) return;
  noResults.hidden = hasResults;
}

function renderPages(total, hits, moreHref) {
  const wrapper = document.getElementById('hits-pages-wrapper');
  const container = document.getElementById('hits-pages');
  const heading = document.getElementById('hits-pages-heading');

  if (total === 0) {
    wrapper.hidden = true;
    return;
  }

  heading.textContent = Drupal.t('Results for content (@count)', { '@count': total });
  container.textContent = '';
  hits.forEach(({ url, text }) => {
    const a = document.createElement('a');
    a.href = url;
    a.textContent = text;
    container.appendChild(a);
  });

  let moreLink = document.getElementById('pages__view-more-link');
  if (!moreLink) {
    moreLink = document.createElement('a');
    moreLink.id = 'pages__view-more-link';
    moreLink.classList.add('button', 'ic-ellipsis', 'right');
    wrapper.appendChild(moreLink);
  }
  moreLink.href = moreHref;
  moreLink.textContent = Drupal.t('More');
  wrapper.hidden = false;
}

function renderProducts(total, hits, moreHref) {
  const wrapper = document.getElementById('hits-products-wrapper');
  const container = document.getElementById('hits-products');
  const heading = document.getElementById('hits-products-heading');

  if (total === 0) {
    wrapper.hidden = true;
    return;
  }

  heading.textContent = Drupal.t('Results for products (@count)', { '@count': total });
  container.textContent = '';
  hits.forEach(({ url, text }) => {
    const a = document.createElement('a');
    a.href = url;
    a.textContent = text;
    container.appendChild(a);
  });

  let moreLink = document.getElementById('products__view-more-link');
  if (!moreLink) {
    moreLink = document.createElement('a');
    moreLink.id = 'products__view-more-link';
    moreLink.classList.add('button', 'ic-ellipsis', 'right');
    wrapper.appendChild(moreLink);
  }
  moreLink.href = moreHref;
  moreLink.textContent = Drupal.t('More');
  wrapper.hidden = false;
}

function createSearchInput(onSubmit) {
  const searchboxEl = document.getElementById('searchbox');
  if (!searchboxEl) return;
  const input = document.createElement('input');
  input.type = 'search';
  input.className = 'dehn-fw-form-field';
  input.placeholder = Drupal.t('Enter your search term...');
  searchboxEl.appendChild(input);

  let debounceTimer;
  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const query = input.value.trim();
      if (query) {
        onSubmit(query);
      } else {
        clearResults();
      }
    }, 200);
  });
}

// Direct fetch-based search

function initFetchSearch() {
  const MEILISEARCH = settings.searchUrl;

  createSearchInput(submitSearch);

  async function submitSearch(query) {
    const baseQuery = {
      q: query,
      limit: 4,
      offset: 0,
      attributesToCrop: ['description:50'],
      cropMarker: '...',
    };

    const payload = {
      queries: [
        {
          ...baseQuery,
          indexUid: PAGES_INDEX,
          filter: CONTENT_FILTER,
        },
        {
          ...baseQuery,
          indexUid: PRODUCTS_INDEX,
          filter: [
            '(salesStatus NOT IN [05,90]) AND articleURL EXISTS AND articleURL IS NOT EMPTY AND articleURL IS NOT NULL AND imageURL EXISTS AND imageURL IS NOT EMPTY AND imageURL IS NOT NULL AND familyName EXISTS AND familyName IS NOT EMPTY AND familyName IS NOT NULL AND typeName EXISTS AND typeName IS NOT EMPTY AND typeName IS NOT NULL AND articleId EXISTS AND articleId IS NOT EMPTY AND articleId IS NOT NULL AND language="' + locale + '" AND country="' + country + '"',
          ],
        },
      ],
    };

    const response = await fetch(MEILISEARCH, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${settings.apiKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    if (!result.results) return;

    const contentData = result.results.find(r => r.indexUid === PAGES_INDEX);
    const productData = result.results.find(r => r.indexUid === PRODUCTS_INDEX);

    renderPages(
      contentData?.estimatedTotalHits ?? 0,
      (contentData?.hits ?? []).map(hit => ({
        url: hit.url.replace('/' + lang + '/', '/' + lang.toLowerCase() + '/'),
        text: (hit.metaTitle || hit.title) + (hit.metaDescription ? ` | ${hit.metaDescription}` : ''),
      })),
      `${settings.pagesMoreUrl}&q=${encodeURIComponent(query)}`
    );
    renderProducts(
      productData?.estimatedTotalHits ?? 0,
      (productData?.hits ?? []).map(hit => ({
        url: hit.articleURL,
        text: hit.articleId ? `${hit.productName} | ${Drupal.t('Part No.')} ${hit.articleId}` : hit.productName,
      })),
      `${settings.productsMoreUrl}&q=${encodeURIComponent(query)}`
    );
    renderNoResults((contentData?.estimatedTotalHits > 0) || (productData?.estimatedTotalHits > 0));
  }

}

// DehnSearch fallback (zh-hans, ja)
function initDehnSearch() {
  const baseUrl = `/store/s?locale=${lang}`;

  createSearchInput(submitDehnSearch);

  async function submitDehnSearch(query) {
    const searchUrl = new URL(baseUrl, window.location.origin);
    searchUrl.searchParams.set('mode', 'quick');
    searchUrl.searchParams.set('format', 'json');
    searchUrl.searchParams.set('limit', 4);
    searchUrl.searchParams.set('q', query);

    const data = await fetch(searchUrl).then(res => res.json());

    renderPages(
      data.contentHits ?? 0,
      data.hits.filter(h => h.category === 'content').map(h => ({ url: h.url, text: h.name })),
      `${settings.pagesMoreUrl}&q=${encodeURIComponent(query)}`
    );
    renderProducts(
      data.hierarchyHits ?? 0,
      data.hits.filter(h => h.category === 'hierarchy').map(h => ({ url: h.url, text: h.name })),
      `${settings.productsMoreUrl}&q=${encodeURIComponent(query)}`
    );
    renderNoResults((data.contentHits > 0) || (data.hierarchyHits > 0));
  }

}
